import { connectRouter } from 'connected-react-router';
import type { RouterState } from 'connected-react-router';
import { combineReducers } from 'redux';
import { reducer as form } from 'redux-form';
import type { FormStateMap } from 'redux-form';

import { history } from 'app/utils/history';

import { auth } from './auth';
import type { Auth } from './auth';
import { bills } from './bills';
import type { Bills } from './bills';
import { conf } from './conf';
import type { Conf } from './conf';
import { edition } from './edition';
import { entities } from './entities';
import { hotelAdmin } from './hotelAdmin';
import type { HotelAdmin } from './hotelAdmin';
import { hotels } from './hotels';
import type { Hotels } from './hotels';
import type { Navigation } from './navigation';
import { navigation } from './navigation';
import { pictures } from './pictures';
import type { Pictures } from './pictures';
import { tags } from './tags';
import type { Tags } from './tags';

export type ApplicationState = {
  auth: Auth;
  bills: Bills;
  form: FormStateMap;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- JS reducer without TypeScript types
  edition: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- JS reducer without TypeScript types
  entities: any;
  navigation: Navigation;
  hotelAdmin: HotelAdmin;
  hotels: Hotels;
  pictures: Pictures;
  conf: Conf;
  router: RouterState;
  tags: Tags;
};

export const rootReducer = combineReducers<ApplicationState>({
  auth,
  bills,
  form,
  edition,
  entities,
  navigation,
  hotelAdmin,
  hotels,
  pictures,
  conf,
  router: connectRouter(history),
  tags,
});
